module.exports = __webpack_public_path__ + "static/media/clutch_logo.a2d07712.png";